<template>
  <div class="min-h-screen bg-background">
    <div class="container mx-auto px-4 py-8">
      <div class="grid grid-cols-1 lg:grid-cols-4 gap-8">
        <!-- Sidebar -->
        <div class="lg:col-span-1">
          <div class="bg-card border border-border rounded-lg shadow-md">
            <div class="p-6">
              <div class="text-center mb-6">
                <div class="w-20 h-20 bg-gradient-primary rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg class="h-10 w-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                  </svg>
                </div>
                <h2 class="text-xl font-semibold text-foreground">
                  {{ user?.first_name || user?.name || 'Utilisateur' }} {{ user?.last_name || '' }}
                </h2>
                <p class="text-sm text-muted-foreground">
                  {{ user?.email || '' }}
                </p>
              </div>

              <nav class="space-y-2">
                <button
                  @click="activeTab = 'overview'"
                  :class="`w-full flex items-center space-x-3 px-3 py-2 rounded-md text-left transition-colors ${
                    activeTab === 'overview'
                      ? 'bg-primary text-white'
                      : 'hover:bg-muted'
                  }`"
                >
                  <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                  </svg>
                  <span>Aperçu</span>
                </button>
                
                <button
                  @click="activeTab = 'orders'"
                  :class="`w-full flex items-center space-x-3 px-3 py-2 rounded-md text-left transition-colors ${
                    activeTab === 'orders'
                      ? 'bg-primary text-white'
                      : 'hover:bg-muted'
                  }`"
                >
                  <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/>
                  </svg>
                  <span>Mes commandes</span>
                </button>
                
                <button
                  @click="activeTab = 'wishlist'"
                  :class="`w-full flex items-center space-x-3 px-3 py-2 rounded-md text-left transition-colors ${
                    activeTab === 'wishlist'
                      ? 'bg-primary text-white'
                      : 'hover:bg-muted'
                  }`"
                >
                  <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
                  </svg>
                  <span>Ma wishlist</span>
                </button>
                
                <button
                  @click="activeTab = 'profile'"
                  :class="`w-full flex items-center space-x-3 px-3 py-2 rounded-md text-left transition-colors ${
                    activeTab === 'profile'
                      ? 'bg-primary text-white'
                      : 'hover:bg-muted'
                  }`"
                >
                  <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                  </svg>
                  <span>Mon profil</span>
                </button>
                
                <button
                  @click="handleLogout"
                  class="w-full flex items-center space-x-3 px-3 py-2 rounded-md text-left hover:bg-red-50 hover:text-red-600 transition-colors"
                >
                  <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
                  </svg>
                  <span>Déconnexion</span>
                </button>
              </nav>
            </div>
          </div>
        </div>

        <!-- Main Content -->
        <div class="lg:col-span-3">
          <!-- Overview Tab -->
          <div v-if="activeTab === 'overview'" class="space-y-6">
            <h1 class="text-3xl font-bold text-foreground">
              Bienvenue, {{ user?.first_name || user?.name || 'Utilisateur' }} !
            </h1>

            <!-- Quick Stats -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div class="bg-card border border-border rounded-lg shadow-md">
                <div class="p-6 text-center">
                  <svg class="h-8 w-8 text-primary mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/>
                  </svg>
                  <h3 class="text-2xl font-bold">{{ orders.length }}</h3>
                  <p class="text-muted-foreground">Commandes</p>
                </div>
              </div>
              
              <div class="bg-card border border-border rounded-lg shadow-md">
                <div class="p-6 text-center">
                  <svg class="h-8 w-8 text-primary mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
                  </svg>
                  <h3 class="text-2xl font-bold">{{ wishlists.length }}</h3>
                  <p class="text-muted-foreground">Favoris</p>
                </div>
              </div>
              
              <div class="bg-card border border-border rounded-lg shadow-md">
                <div class="p-6 text-center">
                  <svg class="h-8 w-8 text-primary mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
                  </svg>
                  <h3 class="text-2xl font-bold">
                    {{ formatPrice(totalSpent) }}
                  </h3>
                  <p class="text-muted-foreground">Total dépensé</p>
                </div>
              </div>
            </div>

            <!-- Recent Orders -->
            <div class="bg-card border border-border rounded-lg shadow-md">
              <div class="p-6">
                <div class="flex items-center justify-between mb-4">
                  <h2 class="text-xl font-semibold">Commandes récentes</h2>
                  <button
                    @click="activeTab = 'orders'"
                    class="border border-input bg-background hover:bg-accent hover:text-accent-foreground px-4 py-2 rounded-md text-sm transition-colors"
                  >
                    Voir tout
                  </button>
                </div>
                
                <div class="space-y-4">
                  <div v-for="order in recentOrders" :key="order.id" class="flex items-center justify-between p-4 border rounded-lg">
                    <div>
                      <p class="font-medium">Commande #{{ order.order_number }}</p>
                      <p class="text-sm text-muted-foreground">
                        {{ formatDate(order.created_at) }}
                      </p>
                      <p class="text-xs text-muted-foreground">
                        {{ order.items_count || order.order_items?.length || 0 }} article(s)
                      </p>
                    </div>
                    <div class="text-right">
                      <span :class="`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(order.status)}`">
                        {{ getStatusLabel(order.status) }}
                      </span>
                      <p class="text-sm font-medium mt-1">
                        {{ formatPrice(order.total) }}
                      </p>
                    </div>
                  </div>
                  
                  <div v-if="!recentOrders.length" class="text-center py-4 text-muted-foreground">
                    <p>Aucune commande récente</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Orders Tab -->
          <div v-else-if="activeTab === 'orders'" class="space-y-6">
            <h1 class="text-3xl font-bold text-foreground">
              Mes commandes
            </h1>

            <div v-if="orders.length > 0" class="space-y-6">
              <div v-for="order in orders" :key="order.id" class="bg-card border border-border rounded-lg shadow-md">
                <div class="p-6">
                  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4">
                    <div>
                      <h3 class="text-lg font-semibold">Commande #{{ order.order_number }}</h3>
                      <p class="text-sm text-muted-foreground">
                        Commandé le {{ formatDate(order.created_at) }}
                      </p>
                      <p v-if="order.shipping_address" class="text-sm text-muted-foreground">
                        Livraison: {{ order.shipping_address }}
                      </p>
                    </div>
                    <div class="flex items-center space-x-4 mt-4 sm:mt-0">
                      <div class="text-right">
                        <span :class="`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(order.status)}`">
                          {{ getStatusLabel(order.status) }}
                        </span>
                        <p class="text-lg font-bold mt-1">
                          {{ formatPrice(order.total) }}
                        </p>
                      </div>
                      <div class="flex  space-x-2">

        
                        <button  v-if="order.status==1||order.status==2"
                          @click="cancelorder(order)"
                          class="border border-input bg-red-500 hover:bg-red600 hover:text-accent-foreground px-3 py-2 rounded-md text-sm transition-colors flex items-center"
                        >
                          annuler
                        </button>
                        <button 
                          v-if="order.status == 2 || order.status == 3 || order.status == 4"
                          @click="downloadInvoice(order)"
                          class="border border-input bg-background hover:bg-accent hover:text-accent-foreground px-3 py-2 rounded-md text-sm transition-colors flex items-center"
                        >
                          <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/>
                          </svg>
                          Facture
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Order Items -->
                  <div v-if="order.items && order.items.length > 0" class="space-y-3">
                    <div v-for="(item, index) in order.items" :key="index" class="flex items-center space-x-4">
                      <img 
                        :src="getProductImage(item)" 
                        :alt="item.product_name"
                        class="w-16 h-16 object-cover rounded-md"
                        @error="handleImageError"
                      />
                      <div class="flex-1">
                        <p class="font-medium">{{ item.product_name }}</p>
                        <p class="text-sm text-muted-foreground">
                          Quantité: {{ item.quantity }}
                          <span v-if="item.size"> • Taille: {{ item.size }}</span>
                          <span v-if="item.color"> • Couleur: {{ item.color }}</span>
                        </p>
                      </div>
                      <span class="font-medium">
                        {{ formatPrice(item.total) }}
                      </span>
                    </div>
                  </div>
                  
                  <!-- Order Summary -->
                  <div class="border-t pt-4 mt-4">
                    <div class="flex justify-between text-sm">
                      <span>Sous-total:</span>
                      <span>{{ formatPrice(order.subtotal) }}</span>
                    </div>
                    <div class="flex justify-between text-sm">
                      <span>Livraison:</span>
                      <span>{{ formatPrice(order.shipping) }}</span>
                    </div>
                    <div v-if="order.discount > 0" class="flex justify-between text-sm text-green-600">
                      <span>Réduction:</span>
                      <span>-{{ formatPrice(order.discount) }}</span>
                    </div>
                    <div class="flex justify-between font-bold text-lg mt-2">
                      <span>Total:</span>
                      <span>{{ formatPrice(order.total) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="bg-card border border-border rounded-lg shadow-md">
              <div class="p-12 text-center">
                <svg class="h-16 w-16 text-muted-foreground mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <h3 class="text-xl font-semibold mb-2">
                  Aucune commande
                </h3>
                <p class="text-muted-foreground mb-6">
                  Vous n'avez pas encore passé de commande
                </p>
                <router-link to="/">
                  <button class="bg-primary hover:bg-primary-hover text-primary-foreground font-semibold py-2 px-4 rounded-md transition-colors">
                    Découvrir nos produits
                  </button>
                </router-link>
              </div>
            </div>
          </div>

          <!-- Wishlist Tab -->
          <div v-else-if="activeTab === 'wishlist'" class="space-y-6">
            <h1 class="text-3xl font-bold text-foreground">
              Ma wishlist
            </h1>

            <div v-if="wishlists.length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div v-for="item in wishlists" :key="item.id" class="bg-card border border-border rounded-lg shadow-md">
                <div class="p-4">
                  <div class="aspect-square mb-4 overflow-hidden rounded-lg">
                    <img 
                      :src="getWishlistProductImage(item)" 
                      :alt="getWishlistProductName(item)"
                      class="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                      @click="goToProduct(item)"
                      @error="handleImageError"
                    />
                  </div>
                  <h3 class="font-semibold mb-2 hover:text-primary cursor-pointer" @click="goToProduct(item)">
                    {{ getWishlistProductName(item) }}
                  </h3>
                  <div class="flex items-center justify-between mb-3">
                    <div>
                      <span class="text-lg font-bold">
                        {{ formatPrice(getWishlistProductPrice(item)) }}
                      </span>
                    </div>
                    <span :class="`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      isProductInStock(item) ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                    }`">
                      {{ isProductInStock(item) ? 'En stock' : 'Rupture' }}
                    </span>
                  </div>
                  <div class="flex space-x-2">
                    <button 
                      v-if="isProductInStock(item)"
                      @click="addToCartWithLoading(item)"
                      class="flex-1 bg-primary hover:bg-primary-hover text-primary-foreground font-semibold py-2 px-4 rounded-md transition-colors flex items-center justify-center"
                      :disabled="addingToCart === item.id"
                    >
                      <svg v-if="addingToCart === item.id" class="animate-spin h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      <svg v-else class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
                      </svg>
                      {{ addingToCart === item.id ? 'Ajout...' : 'Ajouter' }}
                    </button>
                    <button 
                      @click="removeFromWishlistWithLoading(item)"
                      class="border border-input bg-background hover:bg-accent hover:text-accent-foreground p-2 rounded-md transition-colors"
                      :disabled="removingFromWishlist === item.id"
                    >
                      <svg v-if="removingFromWishlist === item.id" class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      <svg v-else class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="bg-card border border-border rounded-lg shadow-md">
              <div class="p-12 text-center">
                <svg class="h-16 w-16 text-muted-foreground mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
                </svg>
                <h3 class="text-xl font-semibold mb-2">
                  Votre wishlist est vide
                </h3>
                <p class="text-muted-foreground mb-6">
                  Ajoutez vos produits préférés à votre wishlist
                </p>
                <router-link to="/">
                  <button class="bg-primary hover:bg-primary-hover text-primary-foreground font-semibold py-2 px-4 rounded-md transition-colors">
                    Découvrir nos produits
                  </button>
                </router-link>
              </div>
            </div>
          </div>

          <!-- Profile Tab -->
          <div v-else-if="activeTab === 'profile'" class="space-y-6">
            <h1 class="text-3xl font-bold text-foreground">
              Mon profil
            </h1>

            <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <!-- Personal Information -->
              <div class="bg-card border border-border rounded-lg shadow-md">
                <div class="p-6">
                  <h2 class="text-xl font-semibold mb-4">
                    Informations personnelles
                  </h2>
                  <form @submit.prevent="updateProfile" class="space-y-4">
                    <div class="grid grid-cols-2 gap-4">
                      <div>
                        <label for="firstName" class="block text-sm font-medium text-foreground mb-2">Prénom *</label>
                        <input 
                          id="firstName" 
                          v-model="profileForm.first_name"
                          required
                          class="w-full px-3 py-2 border border-input rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                          :class="{ 'border-red-500': errors.first_name }"
                        />
                        <p v-if="errors.first_name" class="text-red-500 text-sm mt-1">{{ errors.first_name }}</p>
                      </div>
                      <div>
                        <label for="lastName" class="block text-sm font-medium text-foreground mb-2">Nom *</label>
                        <input 
                          id="lastName" 
                          v-model="profileForm.last_name"
                          required
                          class="w-full px-3 py-2 border border-input rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                          :class="{ 'border-red-500': errors.last_name }"
                        />
                        <p v-if="errors.last_name" class="text-red-500 text-sm mt-1">{{ errors.last_name }}</p>
                      </div>
                    </div>
                    
                    <div>
                      <label for="email" class="block text-sm font-medium text-foreground mb-2">Email *</label>
                      <div class="relative">
                        <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                        </svg>
                        <input 
                          id="email" 
                          type="email"
                          v-model="profileForm.email"
                          required
                          class="w-full pl-10 pr-4 py-2 border border-input rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                          :class="{ 'border-red-500': errors.email }"
                        />
                        <p v-if="errors.email" class="text-red-500 text-sm mt-1">{{ errors.email }}</p>
                      </div>
                    </div>
                    
                    <div>
                      <label for="phone" class="block text-sm font-medium text-foreground mb-2">Téléphone *</label>
                      <div class="relative">
                        <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                        </svg>
                        <input 
                          id="phone" 
                          type="tel"
                          v-model="profileForm.phone"
                          required
                          class="w-full pl-10 pr-4 py-2 border border-input rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                          :class="{ 'border-red-500': errors.phone }"
                        />
                        <p v-if="errors.phone" class="text-red-500 text-sm mt-1">{{ errors.phone }}</p>
                      </div>
                    </div>
                    
                    <button 
                      type="submit" 
                      class="w-full bg-primary hover:bg-primary-hover text-primary-foreground font-semibold py-2 px-4 rounded-md transition-colors flex items-center justify-center"
                      :disabled="updatingProfile"
                    >
                      <svg v-if="updatingProfile" class="animate-spin h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      {{ updatingProfile ? 'Sauvegarde...' : 'Sauvegarder les modifications' }}
                    </button>
                  </form>
                </div>
              </div>

              <!-- Address -->
              <div class="bg-card border border-border rounded-lg shadow-md">
                <div class="p-6">
                  <h2 class="text-xl font-semibold mb-4">
                    Adresse de livraison
                  </h2>
                  <form @submit.prevent="updateAddress" class="space-y-4">
                    <div>
                      <label for="address" class="block text-sm font-medium text-foreground mb-2">Adresse *</label>
                      <div class="relative">
                        <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                        </svg>
                        <input 
                          id="address" 
                          v-model="addressForm.address"
                          required
                          class="w-full pl-10 pr-4 py-2 border border-input rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                          :class="{ 'border-red-500': errors.address }"
                        />
                        <p v-if="errors.address" class="text-red-500 text-sm mt-1">{{ errors.address }}</p>
                      </div>
                    </div>
                    
                    <div class="grid grid-cols-2 gap-4">
                      <div>
                        <label for="city" class="block text-sm font-medium text-foreground mb-2">Ville *</label>
                        <input 
                          id="city" 
                          v-model="addressForm.city"
                          required
                          class="w-full px-3 py-2 border border-input rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                          :class="{ 'border-red-500': errors.city }"
                        />
                        <p v-if="errors.city" class="text-red-500 text-sm mt-1">{{ errors.city }}</p>
                      </div>
                      <div>
                        <label for="postalCode" class="block text-sm font-medium text-foreground mb-2">Code postal *</label>
                        <input 
                          id="postalCode" 
                          v-model="addressForm.postal_code"
                          required
                          class="w-full px-3 py-2 border border-input rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                          :class="{ 'border-red-500': errors.postal_code }"
                        />
                        <p v-if="errors.postal_code" class="text-red-500 text-sm mt-1">{{ errors.postal_code }}</p>
                      </div>
                    </div>
                    
                    <div>
                      <label for="country" class="block text-sm font-medium text-foreground mb-2">Pays *</label>
                      <select 
                        id="country"
                        v-model="addressForm.country"
                        required
                        class="w-full px-3 py-2 border border-input rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                        :class="{ 'border-red-500': errors.country }"
                      >
                        <option value="">Sélectionner un pays</option>
                        <option value="Cameroun">Cameroun</option>
                        <option value="France">France</option>
                        <option value="Belgique">Belgique</option>
                        <option value="Suisse">Suisse</option>
                      </select>
                      <p v-if="errors.country" class="text-red-500 text-sm mt-1">{{ errors.country }}</p>
                    </div>
                    
                    <button 
                      type="submit" 
                      class="w-full bg-primary hover:bg-primary-hover text-primary-foreground font-semibold py-2 px-4 rounded-md transition-colors flex items-center justify-center"
                      :disabled="updatingAddress"
                    >
                      <svg v-if="updatingAddress" class="animate-spin h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      {{ updatingAddress ? 'Mise à jour...' : 'Mettre à jour l\'adresse' }}
                    </button>
                  </form>
                </div>
              </div>
            </div>

            <!-- Change Password -->
            <div class="bg-card border border-border rounded-lg shadow-md">
              <div class="p-6">
                <h2 class="text-xl font-semibold mb-4">
                  Modifier le mot de passe
                </h2>
                <form @submit.prevent="changePassword" class="space-y-4 max-w-md">
                  <div>
                    <label for="currentPassword" class="block text-sm font-medium text-foreground mb-2">Mot de passe actuel *</label>
                    <input 
                      id="currentPassword" 
                      type="password"
                      v-model="passwordForm.current_password"
                      required
                      class="w-full px-3 py-2 border border-input rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                      :class="{ 'border-red-500': errors.current_password }"
                    />
                    <p v-if="errors.current_password" class="text-red-500 text-sm mt-1">{{ errors.current_password }}</p>
                  </div>
                  
                  <div>
                    <label for="newPassword" class="block text-sm font-medium text-foreground mb-2">Nouveau mot de passe *</label>
                    <input 
                      id="newPassword" 
                      type="password"
                      v-model="passwordForm.new_password"
                      required
                      class="w-full px-3 py-2 border border-input rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                      :class="{ 'border-red-500': errors.new_password }"
                    />
                    <p v-if="errors.new_password" class="text-red-500 text-sm mt-1">{{ errors.new_password }}</p>
                  </div>
                  
                  <div>
                    <label for="confirmNewPassword" class="block text-sm font-medium text-foreground mb-2">Confirmer le nouveau mot de passe *</label>
                    <input 
                      id="confirmNewPassword" 
                      type="password"
                      v-model="passwordForm.new_password_confirmation"
                      required
                      class="w-full px-3 py-2 border border-input rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                      :class="{ 'border-red-500': errors.new_password_confirmation }"
                    />
                    <p v-if="errors.new_password_confirmation" class="text-red-500 text-sm mt-1">{{ errors.new_password_confirmation }}</p>
                  </div>
                  
                  <button 
                    type="submit" 
                    class="bg-primary hover:bg-primary-hover text-primary-foreground font-semibold py-2 px-4 rounded-md transition-colors flex items-center justify-center"
                    :disabled="changingPassword"
                  >
                    <svg v-if="changingPassword" class="animate-spin h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {{ changingPassword ? 'Modification...' : 'Changer le mot de passe' }}
                  </button>
                </form>
              </div>
            </div>
            
            <!-- Account Actions -->
            <div class="bg-card border border-border rounded-lg shadow-md">
              <div class="p-6">
                <h2 class="text-xl font-semibold mb-4 text-red-600">
                  Zone de danger
                </h2>
                <div class="space-y-3">
                  <button 
                    @click="deleteAccount"
                    class="w-full bg-red-50 hover:bg-red-100 text-red-600 font-semibold py-2 px-4 rounded-md transition-colors flex items-center justify-center border border-red-200"
                  >
                    <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                    Supprimer mon compte
                  </button>
                  <p class="text-sm text-muted-foreground">
                    Cette action est irréversible. Toutes vos données seront définitivement supprimées.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios' ;
export default {
  name: 'AccountPage',
  
  data() {
    return {
      activeTab: 'overview',
      profileForm: {
        first_name: '',
        last_name: '',
        email: '',
        phone: ''
      },
      addressForm: {
        address: '',
        city: '',
        postal_code: '',
        country: ''
      },
      passwordForm: {
        current_password: '',
        new_password: '',
        new_password_confirmation: ''
      },
      errors: {},
      updatingProfile: false,
      updatingAddress: false,
      changingPassword: false,
      addingToCart: null,
      removingFromWishlist: null
    }
  },
  
  computed: {
    ...mapState(['user', 'orders', 'wishlists', 'cart', 'baseUrl']),
    
    recentOrders() {
      // Trier par date et prendre les 3 plus récentes
      return [...this.orders]
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .slice(0, 3)
    },
    
    totalSpent() {
      return this.orders.reduce((sum, order) => sum + (parseFloat(order.total) || 0), 0)
    }
  },
  
  methods: {
    ...mapActions([
      'logout', 
      'addToCart', 
      'removeFromWishlist',
      'addToWishlist',
      'updateOrderStatus',
      'fetchUserData'
    ]),
    
    getStatusColor(status) {
      const statusNum = parseInt(status)
      switch (statusNum) {
        case 4: return 'bg-green-100 text-green-800' // Livré
        case 3: return 'bg-blue-100 text-blue-800' // Expédié
        case 2: return 'bg-purple-100 text-purple-800' // Accepté
        case 1: return 'bg-yellow-100 text-yellow-800' // En cours
        case 0: return 'bg-red-100 text-red-800' // Rejeté
        default: return 'bg-gray-100 text-gray-800'
      }
    },
    
    getStatusLabel(status) {
      const statusNum = parseInt(status)
      const labels = {
        0: 'Rejeté',
        1: 'En cours',
        2: 'Accepté',
        3: 'Expédié',
        4: 'Livré',
        5: 'Annulé'
      }
      return labels[statusNum] || `Statut ${status}`
    },
    
    formatPrice(price) {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'XAF',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(price)
    },
    
    formatDate(dateString) {
      if (!dateString) return ''
      try {
        const date = new Date(dateString)
        if (isNaN(date.getTime())) return dateString
        return date.toLocaleDateString('fr-FR', { 
          day: '2-digit',
          month: 'long', 
          year: 'numeric' 
        })
      } catch (error) {
        return dateString
      }
    },
    
    getProductImage(item) {
      // Utiliser la structure de données de votre store
      if (item.product?.images && item.product.images.length > 0) {
        const image = item.product.images[0]
        return image.startsWith('http') ? image : `${this.baseUrl}${image}`
      }
      
      // Fallback si l'image n'est pas disponible
      if (item.product?.cover_image) {
        const image = item.product.cover_image
        return image.startsWith('http') ? image : `${this.baseUrl}${image}`
      }
      
      // Placeholder basé sur le nom du produit
      if (item.product_name) {
        const initials = item.product_name.substring(0, 2).toUpperCase()
        return `https://ui-avatars.com/api/?name=${encodeURIComponent(initials)}&background=random&color=fff&size=80`
      }
      
      return 'https://ui-avatars.com/api/?name=PR&background=ccc&color=fff&size=80'
    },
    
    getWishlistProductImage(item) {
      // Structure de wishlist de votre store
      if (item.images && item.images.length > 0) {
        const image = item.images[0]
        return image.startsWith('http') ? image : `${this.baseUrl}${image}`
      }
      
      if (item.product?.images && item.product.images.length > 0) {
        const image = item.product.images[0]
        return image.startsWith('http') ? image : `${this.baseUrl}${image}`
      }
      
      if (item.cover_image) {
        const image = item.cover_image
        return image.startsWith('http') ? image : `${this.baseUrl}${image}`
      }
      
      if (item.name) {
        const initials = item.name.substring(0, 2).toUpperCase()
        return `https://ui-avatars.com/api/?name=${encodeURIComponent(initials)}&background=random&color=fff&size=300`
      }
      
      return 'https://ui-avatars.com/api/?name=PR&background=ccc&color=fff&size=300'
    },
    
    getWishlistProductName(item) {
      return item.name || item.product?.name || 'Produit'
    },
    
    getWishlistProductPrice(item) {
      return item.discounted_price || item.price || item.product?.price || 0
    },
    
    isProductInStock(item) {
      // Vérifier si le produit est en stock
      const stock = item.stock_quantity !== undefined ? item.stock_quantity : item.product?.stock_quantity
      return stock > 0 || stock === undefined
    },
    
    goToProduct(item) {
      const productId = item.product_id || item.id
      this.$router.push(`/product/${productId}`)
    },
    
    handleImageError(event) {
      // Remplacer l'image par un placeholder en cas d'erreur
      const initials = event.target.alt?.substring(0, 2) || 'PR'
      event.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(initials)}&background=ccc&color=fff&size=80`
    },
    async cancelorder(order){
      // window.confirm("Êtes-vous sûr de vouloir annuler cette commande ?")
    
      try {
        await axios.get(this.$store.state.localhost + `cancelorder/${order.id}`,  {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        // this.$toast.success('Commande annulée avec succès')
        // Mettre à jour la liste des commandes
        this.fetchUserData()
      } catch (error) {
        alert(error.response?.data?.message || 'Erreur lors de l\'annulation de la commande')
        console.error('Erreur lors de l\'annulation de la commande:', error)
        // this.$toast.error(error.response?.data?.message || 'Erreur lors de l\'annulation de la commande')
      }
    },
    async handleLogout() {
      try {
        await this.logout()
        this.$router.push('/')
      } catch (error) {
        console.error('Erreur lors de la déconnexion:', error)
        this.$toast.error('Erreur lors de la déconnexion')
      }
    },
    
    async updateProfile() {
      this.updatingProfile = true
      this.errors = {}
      
      try {
        // Utiliser l'URL de votre store
        const response = await this.$axios.put(this.$store.state.localhost + 'user/profile', this.profileForm, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        
        // Mettre à jour le store
        this.$store.commit('setUser', response.data.user)
        
        this.$toast.success('Profil mis à jour avec succès')
      } catch (error) {
        console.error('Erreur lors de la mise à jour du profil:', error)
        
        if (error.response?.status === 422) {
          this.errors = error.response.data.errors || {}
        } else {
          this.$toast.error(error.response?.data?.message || 'Erreur lors de la mise à jour du profil')
        }
      } finally {
        this.updatingProfile = false
      }
    },
    
    async updateAddress() {
      this.updatingAddress = true
      this.errors = {}
      
      try {
        // Utiliser l'URL de votre store
        const response = await this.$axios.put(this.$store.state.localhost + 'user/address', this.addressForm, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        
        // Mettre à jour le store
        this.$store.commit('setUser', response.data.user)
        
        this.$toast.success('Adresse mise à jour avec succès')
      } catch (error) {
        console.error('Erreur lors de la mise à jour de l\'adresse:', error)
        
        if (error.response?.status === 422) {
          this.errors = error.response.data.errors || {}
        } else {
          this.$toast.error(error.response?.data?.message || 'Erreur lors de la mise à jour de l\'adresse')
        }
      } finally {
        this.updatingAddress = false
      }
    },
    
    async changePassword() {
      this.changingPassword = true
      this.errors = {}
      
      try {
        // Utiliser l'URL de votre store
        await this.$axios.put(this.$store.state.localhost + 'user/password', this.passwordForm, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        
        // Réinitialiser le formulaire
        this.passwordForm = {
          current_password: '',
          new_password: '',
          new_password_confirmation: ''
        }
        
        this.$toast.success('Mot de passe changé avec succès')
      } catch (error) {
        console.error('Erreur lors du changement de mot de passe:', error)
        
        if (error.response?.status === 422) {
          this.errors = error.response.data.errors || {}
        } else if (error.response?.status === 401) {
          this.errors.current_password = 'Mot de passe actuel incorrect'
        } else {
          this.$toast.error(error.response?.data?.message || 'Erreur lors du changement de mot de passe')
        }
      } finally {
        this.changingPassword = false
      }
    },
    
    async addToCartWithLoading(item) {
      this.addingToCart = item.id || item.product_id
      try {
        const cartData = {
          id: item.product_id || item.id,
          quantity: 1,
          size: item.size || null,
          color: item.color || null
        }
        
        await this.addToCart(cartData)
        // this.$toast.success('Produit ajouté au panier')
      } catch (error) {
        console.error('Erreur lors de l\'ajout au panier:', error)
        // this.$toast.error(error.response?.data?.message || 'Erreur lors de l\'ajout au panier')
      } finally {
        this.addingToCart = null
      }
    },
    
    async removeFromWishlistWithLoading(item) {
      this.removingFromWishlist = item.id || item.wishlist_id
      try {
        const itemId = item.id || item.wishlist_id
        await this.removeFromWishlist(itemId)
        // this.$toast.success('Produit retiré de la wishlist')
      } catch (error) {
        console.error('Erreur lors de la suppression de la wishlist:', error)
        // this.$toast.error(error.response?.data?.message || 'Erreur lors de la suppression de la wishlist')
      } finally {
        this.removingFromWishlist = null
      }
    },
    
    viewOrderDetails(order) {
      // Rediriger vers la page de détails de commande
      this.$router.push(`/order/${order.id}`)
    },
    
    downloadInvoice(order) {
      // Générer une facture PDF
      const invoiceWindow = window.open('', '_blank')
      invoiceWindow.document.write(`
        <html>
          <head>
            <title>Facture ${order.order_number}</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 20px; }
              .header { text-align: center; margin-bottom: 30px; }
              .customer-info { margin-bottom: 20px; }
              table { width: 100%; border-collapse: collapse; margin: 20px 0; }
              th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
              th { background-color: #f5f5f5; }
              .total { font-weight: bold; font-size: 1.2em; }
            </style>
          </head>
          <body>
            <div class="header">
              <h1>Facture #${order.order_number}</h1>
              <p>Date: ${this.formatDate(order.created_at)}</p>
            </div>
            
            <div class="customer-info">
              <h3>Client</h3>
              <p>${order.customer_name}</p>
              <p>${order.customer_phone}</p>
              <p>${order.shipping_address}</p>
            </div>
            
            <h3>Articles</h3>
            <table>
              <thead>
                <tr>
                  <th>Produit</th>
                  <th>Quantité</th>
                  <th>Prix unitaire</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                ${(order.order_items || []).map(item => `
                  <tr>
                    <td>${item.product_name}</td>
                    <td>${item.quantity}</td>
                    <td>${this.formatPrice(item.price)}</td>
                    <td>${this.formatPrice(item.total)}</td>
                  </tr>
                `).join('')}
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3">Sous-total</td>
                  <td>${this.formatPrice(order.subtotal)}</td>
                </tr>
                <tr>
                  <td colspan="3">Livraison</td>
                  <td>${this.formatPrice(order.shipping)}</td>
                </tr>
                ${order.discount > 0 ? `
                <tr>
                  <td colspan="3">Réduction</td>
                  <td>-${this.formatPrice(order.discount)}</td>
                </tr>
                ` : ''}
                <tr class="total">
                  <td colspan="3">Total</td>
                  <td>${this.formatPrice(order.total)}</td>
                </tr>
              </tfoot>
            </table>
          </body>
        </html>
      `)
      invoiceWindow.document.close()
      invoiceWindow.print()
    },
    
    deleteAccount() {
      if (confirm('Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.')) {
        this.$toast.info('Fonctionnalité de suppression de compte en développement')
      }
    }
  },
  
  mounted() {
    // Initialiser les formulaires avec les données de l'utilisateur
    if (this.user) {
      this.profileForm = {
        first_name: this.user.first_name || this.user.name || '',
        last_name: this.user.last_name || '',
        email: this.user.email || '',
        phone: this.user.phone || ''
      }
      
      // Extraire l'adresse de l'utilisateur
      if (this.user.address) {
        // Si l'adresse est une chaîne, essayez de la parser
        const addressStr = this.user.address
        this.addressForm = {
          address: addressStr,
          city: this.user.city || '',
          postal_code: this.user.postal_code || '',
          country: this.user.country || ''
        }
      }
    }
  },
  
  // Charger les données au montage du composant
  async created() {
    try {
      // Rafraîchir les données utilisateur
      await this.fetchUserData()
    } catch (error) {
      console.error('Erreur lors du chargement des données utilisateur:', error)
    }
  }
}
</script>

<style scoped>
.bg-gradient-primary {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
}

.bg-primary-hover:hover {
  background-color: rgba(59, 130, 246, 0.9);
}

/* Animation pour les images */
img {
  transition: transform 0.3s ease;
}

img:hover {
  transform: scale(1.05);
}
</style>